import React from "react";
import { Link } from "react-router-dom";
import vinesMobWebp from "../assets/hero-vines-1280.webp";
import BookCTA from "./BookCTA";
import "./FinalCTA.css";

const FinalCTA = () => (
  <section
    className="section final-cta"
    style={{
      "--section-bg": "var(--bg-primary)",
      "--cta-vines": `url("${vinesMobWebp}")`,
    }}
  >
    <div className="final-cta-vines" aria-hidden="true" />
    <div className="container final-cta-inner">
      <p className="eyebrow">Start the Conversation</p>
      <h2>
        Ready to explore how AI can
        <br />
        transform your business?
      </h2>
      <div className="final-cta-actions">
        <BookCTA ctaLocation="final_cta" className="btn-primary">
          Book a Free Consultation
        </BookCTA>
        <Link to="/services" className="link-arrow">
          Explore Services <span className="arrow">→</span>
        </Link>
      </div>
    </div>
  </section>
);

export default FinalCTA;
